import { useState } from 'react';

import { DeprecationBanner } from './DeprecationBanner';
import { DeprecationModal } from './DeprecationModal';

export const DeprecationContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <DeprecationBanner onLearnMoreClick={openModal} />
      <DeprecationModal open={isModalOpen} onClose={closeModal} />
    </>
  );
};
